import { Directive, ElementRef, OnInit, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[aut-id]',
  standalone: false
})
export class AutIdDirective implements OnInit {
  @Input('aut-id') inputControlName: string;
  static oldInputControlName = '';
  static idCounter = 0;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    if (AutIdDirective.oldInputControlName !== this.inputControlName) {
      AutIdDirective.oldInputControlName = this.inputControlName;
      AutIdDirective.idCounter = 0;
    }
    const uniqueId = `${this.inputControlName}-${AutIdDirective.idCounter++}`;
    this.renderer.setAttribute(this.el.nativeElement, 'aut-id', uniqueId);
  }
}
